import Kr from 'Kr/kr';

import 'KrComponent/FormAddWWW.js';

const app = new Kr.App;
app.run();
